import {Box, Stack, Typography} from '@mui/material';
import React from 'react';

import {MainHeader, StepProgressBar} from 'presentation/components';
import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';

import {CustomStepper} from 'presentation/components/CustomStepper';
import {GuideStep, stepMap} from 'presentation/modules/guide/shared/constants/constants';
import {MOBILE_STEPS_LABELS} from 'presentation/modules/guide/shared/constants/mobileStepLabels';

import {SearchBarUnit} from 'presentation/modules/guide/shared/ui/components/SearchBarUnit';
import {translations} from 'presentation/translations-new';
import {OdontoGuideHeaderProps} from './types';
import {useOdontoGuideHeader} from './hooks/useOdontoGuideHeader';

const {titleNetworkProviderOdonto} = translations['pt-br'].privateFlow.guideFlow;

export const OdontoGuideHeader = ({allProviders}: OdontoGuideHeaderProps) => {
	const {stepLabels, currentStepState, isMobile, handleBack, handleClose} =
		useOdontoGuideHeader();

	return (
		<MainHeader
			title={titleNetworkProviderOdonto}
			handleBack={handleBack}
			handleClose={handleClose}
			variant="subRoute"
			hideProfileMenu={true}>
			<Stack gap={isMobile ? 1 : 3} px={isMobile ? 2 : 3} pb={isMobile ? '12px' : '20px'}>
				<Box maxWidth={647}>
					{isMobile ? (
						<StepProgressBar
							mt={1}
							currentStep={
								currentStepState
									? stepMap[currentStepState as GuideStep].active + 1
									: 1
							}
							totalSteps={stepLabels.length}
						/>
					) : (
						<CustomStepper
							activeStep={
								currentStepState ? stepMap[currentStepState as GuideStep].active : 0
							}
							stepLabels={stepLabels}
						/>
					)}
				</Box>
				{isMobile ? (
					<Typography variant="body1" fontSize="1.125rem">
						{currentStepState
							? MOBILE_STEPS_LABELS[currentStepState as GuideStep]
							: MOBILE_STEPS_LABELS[GuideStep.LOCATION]}
					</Typography>
				) : null}
			</Stack>
			{currentStepState === GuideStep.RESULTS ? (
				<SearchBarUnit type={PlanTypeEnum.ODONTO} providers={allProviders} />
			) : null}
		</MainHeader>
	);
};
